import AIIB from "@assets/KPMG/FinancingProducts/AIIB.png";
import ADB from "@assets/KPMG/FinancingProducts/Adb.png";
import World from "@assets/KPMG/FinancingProducts/World.png";
import AFD from "@assets/KPMG/FinancingProducts/AFD.jpg";
import KFW from "@assets/KPMG/FinancingProducts/kfw.jpg";
const arr = [];

export const PooledFinancingData = [
  {
    id: "3",
    title: "ADB - Asian Development Bank",
    type: "Concessional Finance",
    provider: "ADB",
    image: ADB,
    links: [
      {
        title: "Public Sector Financing",
        href: "https://www.adb.org/what-we-do/public-sector-financing",
      },
      {
        title: "Private Sector Financing",
        href: "https://www.adb.org/what-we-do/private-sector-financing",
      },
      {
        title: "Financing Partnerships",
        href: "https://www.adb.org/what-we-do/financing-partnerships/main",
      },
    ],
  },
  {
    id: "4",
    title: "AFD",
    type: "Concessional Finance",
    provider: "AFD",
    image: AFD,
    links: [
      {
        title: "AFD - Agence Française de Développement",
        href: "https://www.afd.fr/en/finance-projects",
      },
    ],
  },
  {
    id: "2",
    title: "AIIB",
    type: "Concessional Finance",
    provider: "AIIB",
    image: AIIB,
    links: [
      {
        title: "Sovereign-Backed Financing",
        href: "https://www.aiib.org/en/treasury/_common/_download/AIIB-Sovereign-Backed-Financing-SBF-FactSheet.pdf",
      },
      {
        title: "Non Sovereign-Backed Financing",
        href: "https://www.aiib.org/en/treasury/_common/_download/AIIB-Sovereign-Backed-Financing-SBF-FactSheet.pdf",
      },
      {
        title: "Equity Investment",
        href: "#",
      },
    ],
  },

  {
    id: "5",
    title: "KfW",
    type: "Concessional Finance",
    provider: "KfW",
    image: KFW,
    links: [
      {
        title: "International Financing of KfW | KfW",
        href: "https://www.kfw.de/International-financing/",
      },
    ],
  },

  {
    id: "1",
    title: "World Bank Group",
    type: "Concessional Finance",
    provider: "World Bank Group",
    image: World,
    links: [
      {
        title: "Investment Project Financing",
        href: "https://www.worldbank.org/en/what-we-do/products-and-services/financing-instruments/investment-project-financing",
      },
      {
        title: "Development Policy Financing",
        href: "https://www.worldbank.org/en/what-we-do/products-and-services/financing-instruments/development-policy-financing",
      },
      {
        title: "Program for Results Financing",
        href: "https://www.worldbank.org/en/programs/program-for-results-financing",
      },
    ],
  },
];
